/**
 * Centralized z-index hierarchy for consistent layering across the app.
 *
 * Layer order (lowest to highest):
 * 1. content (0)      - Base page content, cards, grids
 * 2. floatingUI (10)  - Carousel arrows, drag indicators, in-content overlays
 * 3. stickyInPage (20) - In-page sticky headers (ProfilePage, FilterBar)
 * 4. appChrome (30)   - TopBar, Sidebar (app-level fixed chrome)
 * 5. dropdown (40)    - All dropdowns/popovers/tooltips (MUST BE PORTALED)
 * 6. modal (50)       - All modals/dialogs and their backdrops
 * 7. toast (60)       - Toast notifications only
 */
export const Z_INDEX = {
  content: 0,
  floatingUI: 10,
  stickyInPage: 20,
  appChrome: 30,
  dropdown: 40,
  modal: 50,
  toast: 60,
} as const;

export type ZIndexLayer = keyof typeof Z_INDEX;
